import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Route } from "react-router-dom";
import { Card, Steps } from "antd";
import InputName from "./components/InputName";
import Finish from "./components/Finish";
import ScanCode from "./components/ScanCode";
import "./index.css";

const { Step } = Steps;
const urlAndStepMap = {
  "/WeChat/management/add/inputName": 0,
  "/WeChat/management/add/scanCode": 1,
  "/WeChat/management/add/finish": 2,
};

function AddWeChat(props) {
  const [step, setStep] = useState(0);
  const [name, setName] = useState("");

  useEffect(() => {
    const {
      location: { pathname },
    } = props;
    setStep(urlAndStepMap[pathname]);
  }, [props.location.pathname]);

  return (
    <Card>
      <Steps current={step} className="mb20">
        <Step title="设置用户名" />
        <Step title="微信扫码绑定" />
        <Step title="完成" />
      </Steps>
      <Route
        path="/WeChat/management/add/inputName"
        exact
        render={() => {
          return <InputName name={name} changeName={setName} />;
        }}
      />
      <Route
        path="/WeChat/management/add/scanCode"
        exact
        render={() => {
          return <ScanCode name={name} />;
        }}
      />
      <Route
        path="/WeChat/management/add/finish"
        exact
        render={() => {
          return <Finish />;
        }}
      />
    </Card>
  );
}

export default withRouter(AddWeChat);
